/* @flow */
import React from 'react';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import ImageWrapper from 'components/ImageWrapper.jsx';
import Text from 'components/Text.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';
import Link from 'components/Link.jsx';

import './styles/BoxSelectItem.scss';

const BoxSelectItem = React.createClass({
  propTypes: {
    glyph: React.PropTypes.string,
    icon: React.PropTypes.string,
    label: React.PropTypes.string,
    size: React.PropTypes.string,
    action: React.PropTypes.func,
    to: React.PropTypes.string,
    className: React.PropTypes.string,
    border: React.PropTypes.bool,
    eventElementName: React.PropTypes.string,
  },

  statics: {
    propClasses: {
      size: {
        xsmall: 'BoxSelectItem--xsmall',
      },
    },
  },

  renderChildren() {
    const { children } = this.props;

    return (
      <Text color="thunder" element="div" className="BoxSelectItem-text">
        {children}
      </Text>
    );
  },

  render() {
    const classes = cx(
      'BoxSelectItem',
      this.props.className,
      getPropClassesFromInstance(this),
      {
        'BoxSelectItem--border': this.props.border,
      }
    );

    return (
      <ClickEventTrigger eventElementName={this.props.eventElementName}>
        <Link className={classes} onClick={this.props.action} to={this.props.to}>
          <ImageWrapper size="xsmall" className="BoxSelectItem-icon">
            {this.props.icon
              ? <Image src={this.props.icon} />
              // $FlowIssue
              : <Glyph color="brand" name={this.props.glyph} size="xxxlarge" className="BoxSelectItem-glyph" />
            }
          </ImageWrapper>
          {this.props.label &&
            <h3 className="BoxSelectItem-label">
              {this.props.label}
            </h3>
          }
          {this.props.children && this.renderChildren()}
        </Link>
      </ClickEventTrigger>
    );
  },
});

export default BoxSelectItem;



// WEBPACK FOOTER //
// ./src/components/BoxSelectItem.jsx